import {put,takeLatest,call} from 'redux-saga/effects';
import * as optionService from "../../../../services/optionService";
import {
    GET_OPTIONS,
    GET_OPTIONS_SUCCESS,
    GET_OPTIONS_ERROR
}
    from "../../../actions/menu/options";

function* getOptionsSaga(action) {
    try {
        const data=yield call(optionService.GetOptions,action.payload)
        yield put({
            type: GET_OPTIONS_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_OPTIONS_ERROR,error: error.data
        });
    }
}


export function* getOptionsSagaWatcher() {
    yield takeLatest(GET_OPTIONS,getOptionsSaga);
}